__turbopack_context__.v({
  "button": "NotFound-module__wPnwZG__button",
  "centeredContainer": "NotFound-module__wPnwZG__centeredContainer",
  "imageContainer": "NotFound-module__wPnwZG__imageContainer",
  "location": "NotFound-module__wPnwZG__location",
});
